// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"Searchbar_searchBox__O0Ma7","searchIcon":"Searchbar_searchIcon__L0Ed4","searchText":"Searchbar_searchText__hibbW"};